// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3311":"2c5e2f1c","5321":"e2cbe98c"}[chunkId] + ".chunk.css";
};